import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loading from '../../apa/components/Loading';

@connect(
    state => (
        {
            authToken: state.apa.token
        }
    )
)
export default class O365Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            signInUrl: ''
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Loading/>;
        } else {
            return <a href={this.state.signInUrl}>Microsoft Login</a>
        }
    }

}

import PropTypes from 'prop-types';

O365Login.propTypes = {
    authToken: PropTypes.string
}
